// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"TextArea__pc_only___1CW3R","sp_only":"TextArea__sp_only___2N_dY","textarea":"TextArea__textarea___3fVqt"};